module.exports = "<div class=\"popuptext\">\n<p>Year installed: {{ INSTALLDAT }}</p>\n<p>Located at: {{ SITEADDRES }}</p>\n</div>\n"